var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocksmith(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#232A2E;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M45.17,11.51v8.41H41.4v-8.41c0-3.64-2.95-6.61-6.6-6.61s-6.61,2.97-6.61,6.61v8.41h-3.77v-8.41 c0-5.72,4.65-10.38,10.38-10.38C40.52,1.13,45.17,5.79,45.17,11.51z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M45.17,20.51H41.4c-0.33,0-0.59-0.27-0.59-0.59v-8.41c0-3.32-2.69-6.01-6-6.01c-3.32,0-6.01,2.7-6.01,6.01 v8.41c0,0.33-0.27,0.59-0.59,0.59h-3.77c-0.33,0-0.59-0.27-0.59-0.59v-8.41c0-6.05,4.92-10.97,10.97-10.97 c6.04,0,10.96,4.92,10.96,10.97v8.41C45.76,20.24,45.5,20.51,45.17,20.51z M41.99,19.32h2.59v-7.82c0-5.4-4.39-9.79-9.77-9.79 c-5.4,0-9.79,4.39-9.79,9.79v7.82h2.59v-7.82c0-3.97,3.23-7.2,7.2-7.2c3.96,0,7.19,3.23,7.19,7.2V19.32z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000144339426275629333510000010780941132435938732_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M49.41,22.66v23.77c0,1.39-1.13,2.51-2.51,2.51H22.7c-1.39,0-2.51-1.13-2.51-2.51V22.66 c0-1.39,1.13-2.51,2.51-2.51h24.19C48.28,20.15,49.41,21.27,49.41,22.66z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M46.89,49.54H22.7c-1.71,0-3.11-1.39-3.11-3.11V22.66c0-1.71,1.39-3.11,3.11-3.11h24.19 c1.71,0,3.11,1.39,3.11,3.11v23.77C50,48.15,48.61,49.54,46.89,49.54z M22.7,20.74c-1.06,0-1.92,0.86-1.92,1.92v23.77 c0,1.06,0.86,1.92,1.92,1.92h24.19c1.06,0,1.92-0.86,1.92-1.92V22.66c0-1.06-0.86-1.92-1.92-1.92H22.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000177471211050445056860000011938062491092438402_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M36.33,35.15l0.88,5.05h-4.83l0.87-5.05c-1.06-0.56-1.77-1.66-1.77-2.94c0-1.83,1.48-3.31,3.31-3.31 c1.84,0,3.32,1.48,3.32,3.31C38.11,33.49,37.4,34.59,36.33,35.15z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000108987735220588625970000001218108026973678989_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000034806907026894111150000012593569096024958609_"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "9.79,15.64 9.79,47.05 9.79,48.95 6.16,48.95 6.16,46.51 3.07,46.51 3.07,43.37 4.52,43.37  4.52,40.99 3.07,40.99 3.07,37.86 6.16,37.86 6.16,15.64  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M9.79,49.54H6.16c-0.33,0-0.59-0.27-0.59-0.59V47.1H3.07c-0.33,0-0.59-0.27-0.59-0.59v-3.14 c0-0.33,0.27-0.59,0.59-0.59h0.85v-1.19H3.07c-0.33,0-0.59-0.27-0.59-0.59v-3.14c0-0.33,0.27-0.59,0.59-0.59h2.49V15.64 c0-0.33,0.27-0.59,0.59-0.59c0.33,0,0.59,0.27,0.59,0.59v22.21c0,0.33-0.27,0.59-0.59,0.59H3.67v1.95h0.85 c0.33,0,0.59,0.27,0.59,0.59v2.38c0,0.33-0.27,0.59-0.59,0.59H3.67v1.95h2.49c0.33,0,0.59,0.27,0.59,0.59v1.85h2.44V15.64 c0-0.33,0.27-0.59,0.59-0.59c0.33,0,0.59,0.27,0.59,0.59v33.3C10.38,49.27,10.11,49.54,9.79,49.54z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M15.35,8.44c0,4.07-3.3,7.37-7.38,7.37c-4.08,0-7.38-3.3-7.38-7.37c0-4.08,3.3-7.39,7.38-7.39 C12.05,1.05,15.35,4.36,15.35,8.44z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M7.97,16.4C3.58,16.4,0,12.83,0,8.44c0-4.4,3.58-7.98,7.97-7.98c4.4,0,7.97,3.58,7.97,7.98 C15.94,12.83,12.37,16.4,7.97,16.4z M7.97,1.65c-3.74,0-6.79,3.05-6.79,6.8c0,3.73,3.04,6.77,6.79,6.77 c3.74,0,6.78-3.04,6.78-6.77C14.76,4.7,11.71,1.65,7.97,1.65z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000072997717953065057850000002079982612542313099_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.97,4.65c-1.04,0-1.89,0.85-1.89,1.89c0,1.04,0.85,1.89,1.89,1.89c1.04,0,1.89-0.85,1.89-1.89 C9.86,5.5,9.02,4.65,7.97,4.65z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocksmith);
export default __webpack_public_path__ + "static/media/locksmith.eb3f17a3339d3ca0f9f85517ce8258cd.svg";
export { ForwardRef as ReactComponent };